import { CSSProperties } from 'react'

import classNames from 'classnames'

interface TableBodyProps {
  className?: string
  style?: CSSProperties
  children?: React.ReactNode
}

export const TableBody: React.FC<TableBodyProps> = ({
  className,
  style,
  children,
}) => {
  return (
    <tbody
      className={classNames('data-table-body', className)}
      style={{ ...style }}
    >
      {children}
    </tbody>
  )
}
